/** 调用浏览器storage
 * @param key
 * @param value
 * @param boolean
 */
export function setStorage(key, value, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
    value = JSON.stringify(value)
  }
  storageObj.setItem(key, value)
}

// 判断是否是数组
export function ensureArray(param) {
  if (!param) return [];
  if (Array.isArray(param)) {
    return param;
  } else if (typeof param === 'string') {
    // 使用逗号分割字符串，并去除首尾空格
    return param.split(',').map(item => item.trim());
  } else {
    return [];
  }
}

// 获取
export function getStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  return storageObj.getItem(key)
}

// 删除
export function removeStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  storageObj.removeItem(key)
}

// 清空所有
export function removeAllStorage(boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  storageObj.clear()
}


// export function editorIsEmpty(str) {
//   //检查是否有文本
//   var value = str.replace(/\s/g, '').length;
//   //检查有图片？
//   var imgHave = (new RegExp("img", "ig")).test(str);
//   if (value > 0 || imgHave) { return true }
//   return false;
// }

export const editorIsEmpty = (str = '') => {

  if (str) {
    let regx = /<\/?[a-zA-Z]+(\s+[a-zA-Z]+=".*")*>/g;
    str = str.replaceAll(regx, '')
    console.log(str.length, '我是内容') // 我是内容
    return str.length
  }
}
